import { jsx } from 'react/jsx-runtime';
import { Table } from '@dls/web';
import { useCallback } from 'react';
import Loading from '../Loading/index.js';
import { SCTableWrapper } from './styles.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
const AdvancedTable = props => {
  const _a = props,
    {
      isLoading,
      onRowClick,
      hideHeader,
      bgColor,
      verticalAlign,
      style,
      className,
      data
    } = _a,
    args = __objRest(_a, ["isLoading", "onRowClick", "hideHeader", "bgColor", "verticalAlign", "style", "className", "data"]);
  const handleRowClick = useCallback(event => {
    var _a2;
    if (!onRowClick) return;
    const tr = event.target.closest("tr");
    if (tr && ((_a2 = tr.parentNode) == null ? void 0 : _a2.nodeName) === "TBODY") {
      const index = Array.from(tr.parentNode.children).indexOf(tr);
      onRowClick(data[index]);
    }
  }, [onRowClick, data]);
  if (isLoading) {
    return /* @__PURE__ */jsx(Loading, {});
  }
  return /* @__PURE__ */jsx(SCTableWrapper, {
    isRowClickable: onRowClick !== void 0,
    onClick: handleRowClick,
    hideHeader,
    bgColor,
    verticalAlign,
    style,
    className,
    children: /* @__PURE__ */jsx(Table, __spreadValues({
      data
    }, args))
  });
};
export { AdvancedTable as default };